import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-off-white py-16 px-6" data-id="element-116">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-117">
        <p className="text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-118">
          Estás a{' '}
          <strong className="text-navy" data-id="element-119">una reunión de Recursos Humanos</strong>{' '}
          de distancia de perder tu ingreso principal. O tal vez, estás a{' '}
          <strong className="text-navy" data-id="element-120">un lunes más</strong> de sufrir un
          colapso por el estrés de un trabajo que ya no aguantas.
        </p>
        <p className="text-lg md:text-xl text-gray-800 leading-relaxed mt-6" data-id="element-121">
          La mayoría de las personas cometen{' '}
          <strong className="text-red-600" data-id="element-122">
            errores fatales en los primeros 10 minutos
          </strong>{' '}
          de un despido: firman lo que no deben, aceptan migajas por miedo y se
          van sin un plan.{' '}
          <strong className="text-navy" data-id="element-123">No dejes que eso te pase a ti.</strong>
        </p>
      </motion.div>
    </section>;
}